import React, { useMemo } from 'react'
import { Doughnut } from 'react-chartjs-2';

const AlertBySeverityDonutChart = ({ SiteName, handleModalShow, siteId, getcsvFileName, alertsData }) => {
  // Flatten alertsData if it's an object with keys (as in your API response)
  const flatAlertsData = Array.isArray(alertsData)
    ? alertsData
    : alertsData && typeof alertsData === 'object'
      ? Object.values(alertsData).flat()
      : [];

  // Memoize severity labels and values from WidgetID 8
  const { severityLabels, severityCounts } = useMemo(() => {
    let severityLabels = [];
    let severityCounts = [];
    const widget8 = flatAlertsData.find(item => item.WidgetID === 8 && item.WidgetData);
    if (widget8 && widget8.WidgetData.Severity && widget8.WidgetData.AlertCount) {
      severityLabels = widget8.WidgetData.Severity;
      severityCounts = widget8.WidgetData.AlertCount;
    }
    return { severityLabels, severityCounts };
  }, [flatAlertsData]);

  const severityColorMap = {
    Extreme: '#dd2121',
    High: '#d06841',
    Moderate: '#daa926',
    Low: '#83ba2b',
  };
  const backgroundColors = severityLabels.map(severity => severityColorMap[severity] || 'gray');

  const data = {
    labels: severityLabels,
    datasets: [{
      data: severityCounts,
      backgroundColor: backgroundColors,
      hoverOffset: 4
    }]
  };

  const option = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            let dataset = tooltipItem.dataset;
            let value = dataset.data[tooltipItem.dataIndex];
            let label = dataset.labels ? dataset.labels[tooltipItem.dataIndex] : "";
            return `${label}: ${value}`;
          },
        },
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 14,
          fontColor: '#474747',
          fontFamily: '7px Montserrat',
        },
      },
      datalabels: {
        color: "#000",
        font: {
          weight: "bold",
          size: 14,
        },
        align: "top",
        formatter: (value) => value,
      },
      animations: {
        tension: {
          duration: 1000,
          easing: 'active',
          from: 1,
          to: 0,
        }
      },
    },
    onClick: (event, elements, chart) => {
      if (elements && elements.length > 0 && typeof handleModalShow === "function") {
        const element = elements[0];
        const index = element.index;
        const label = chart.data.labels[index];
        handleModalShow({ Severity: label }, "Alert", 30, { SiteID: [siteId] }, getcsvFileName('Alert', label), "Alert Counts By Severity");
      }
    }
  };

  return (
    <div style={{ padding: "10px", height: "90%", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {severityLabels.length > 0 ? (
        <Doughnut data={data} options={option} />
      ) : (
        <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", color: "gray" }}>
          No alerts found
        </div>
      )}
    </div>
  );
}

export default AlertBySeverityDonutChart